const HERU_API = {
	INVOICE_CATALOGS:
		'https://d16nv9v9z1ihe6.cloudfront.net/INVOICE_CATALOG/tos3.json',
};

export default HERU_API;
